// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__95_yf","header":"styles_header__l6NWY","text":"styles_text__vhNU7","functionLayout":"styles_functionLayout__5CfJz"};